module.exports = __webpack_public_path__ + "img/tulikas-logo.0e4a7224.jpg";